import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import css from './style.module.scss';
import NLink from '../NLink';

const Breadcrumbs = (props) => {
	const { links, children } = props;
	return (
		<div className={cn(css.block)}>
			{links.length > 0 && (
				<div className={css.links}>
					{links.map((link, i) => {
						return (
							<>
								<NLink href={link.href}>
									<a className={css.link} href={link.href}>
										{link.label}
									</a>
								</NLink>
								{i + 1 < links.length && (
									<span className={css.divider}>•</span>
								)}
							</>
						);
					})}
				</div>
			)}
			{children}
		</div>
	);
};

Breadcrumbs.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			label: PropTypes.string,
			href: PropTypes.string,
		}),
	),
};

Breadcrumbs.defaultProps = {
	children: undefined,
	links: [],
};

export default Breadcrumbs;
